var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { StatusWrapper } from 'shared/components';
import { useCanIAllOrMine } from '../hooks';
export var RBACProtectedRoute = function (_a) {
    var canIAll = _a.canIAll, canIMine = _a.canIMine, forMember = _a.forMember, children = _a.children;
    var navigate = useNavigate();
    var _b = useState(false), rbacFailed = _b[0], setRbacFailed = _b[1];
    var _c = useState(false), rbacLoading = _c[0], setRbacLoading = _c[1];
    var _d = useState(false), rbacError = _d[0], setRbacError = _d[1];
    var _e = useState(false), rbacFetched = _e[0], setRbacFetched = _e[1];
    if (!forMember) {
        useEffect(function () {
            setRbacFailed(!canIAll && !canIMine);
            setRbacFetched(true);
        }, []);
    }
    else if (forMember) {
        var id = useParams().id;
        var _f = useCanIAllOrMine(id !== null && id !== void 0 ? id : '', !!canIAll, !!canIMine), canIAllOrMine_1 = _f.canI, isLoading_1 = _f.isLoading, isError_1 = _f.isError, isFetched_1 = _f.isFetched;
        useEffect(function () {
            if (!canIAllOrMine_1 && isFetched_1) {
                setRbacFailed(true);
            }
            setRbacLoading(isLoading_1);
            setRbacError(isError_1);
            setRbacFetched(isFetched_1);
        }, [canIAllOrMine_1, isLoading_1, isError_1, isFetched_1]);
    }
    useEffect(function () {
        if (rbacFailed) {
            navigate('/not-found');
        }
    }, [rbacFailed]);
    return (_jsx(StatusWrapper, __assign({ isLoading: rbacLoading || !rbacFetched, isError: rbacError }, { children: rbacFailed ? null : children })));
};
